import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';

DialogChargePointErrorDescriptionView.propTypes = {
  item: PropTypes.object.isRequired,
  onDismiss: PropTypes.func,
};

function DialogChargePointErrorDescriptionView({ item, onDismiss }) {
  const reason = item?.reason;

  return (
    <div>
      <div
        className="d-flex align-items-center justify-content-between px-4 py-3"
        style={{ borderBottom: `1px solid ${AppColors.gray[200]}` }}
      >
        <span style={UIHelper.buildFontStyle('700', '20px', AppColors.gray[800])}>
          Chi tiết mô tả lỗi
        </span>
        <button
          type="button"
          onClick={onDismiss}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: AppColors.gray[500] }}
        >
          <i className="fa-regular fa-xmark" />
        </button>
      </div>

      <div className="px-4 py-4">
        {Utils.isValid(reason) ? (
          <div
            className="p-4"
            style={{
              backgroundColor: AppColors.gray[100],
              borderRadius: '5px',
              border: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            <span
              className="text-left text-break"
              style={UIHelper.buildFontStyle('500', '14px', AppColors.gray[800])}
            >
              {reason}
            </span>
          </div>
        ) : (
          UIHelper.buildEmptyNoData('Không có mô tả lỗi')
        )}
      </div>

      <div
        className="d-flex justify-content-end px-4 py-3"
        style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
      >
        {UIHelper.buildNegativeButton('Bỏ qua', onDismiss)}
      </div>
    </div>
  );
}

export default DialogChargePointErrorDescriptionView;
